
import pagesConfig from "./pagesConfig";
import Theme from "./theme"
import fonts from "./fonts"
const { spacing: Spacing } = Theme.Light;
export {  pagesConfig, Theme, Spacing, fonts};
